import React from "react";
import {Row, Container, Col, Button, Alert, Form, Dropdown} from "react-bootstrap";
import './style.css';
import '../style.css';
import {FaWalking, FaCircle} from 'react-icons/fa';
import {BiTrain, BiChip, BiTimer, BiArrowBack, BiRightArrowAlt} from 'react-icons/bi';
import {AiOutlineControl, AiTwotoneSetting, AiOutlineSchedule, AiOutlineFileExclamation, AiOutlinePoweroff} from 'react-icons/ai';
import {RiLayoutMasonryFill, RiCloseCircleLine} from 'react-icons/ri';
import DateTimePicker from 'react-datetime-picker';

import ListGroup from "react-bootstrap/ListGroup";

import avatar from "../../resources/admin-icon.jpg";
import sha256 from "crypto-js/sha256";
import 'react-calendar/dist/Calendar.css';
import { config } from "../Config";
import {save} from "save-file";

const ACTION_MODE = {
  NONE: 0,
  ACCOUNT: 1,
  DEVICE: 2,
  OTA: 3,
  REPORT: 4,
}

export class ManagementPage extends React.Component {
  constructor(props) {
    super(props);
    this.onClose = props.onClose || null;
    this.getLog = props.getLog || null;
    this.state = {
      mode: ACTION_MODE.ACCOUNT,
      newAccount: false,
      newFirmware: false,
      accountForm: {
        userName: '',
        password: '',
        verifyPassword: '',
        newPassword: '',
        role: 2
      },
      alertForm: {
        email: props.email || '',
        phone: props.phone || '',
      },
      firmwareForm: {
        version: '',
        filePath: '',
      },
      changePassword: false,
      dateValue: new Date(),
      disableDownload: false
    }
    this.user = props.user || "Trần Thanh Lộc";
    this.onDeleteAccount = this.props.onDeleteAccount || null;
    this.onCreateNewAccount = this.props.onCreateNewAccount || null;
    this.uploadFirmware = this.props.uploadFirmware || null;
    this.changePassword = this.props.changePassword || null;
    this.deleteStation = this.props.deleteStation || null;
    this.onUpdateApp = this.props.onUpdateApp || null;
    this.changeAlertInfo = this.props.changeAlertInfo || null;

    this.onChangeActionMode = this.onChangeActionMode.bind(this);
    this.onChangeNewAccount = this.onChangeNewAccount.bind(this);
    this.onChangeNewFirmware = this.onChangeNewFirmware.bind(this);
    this.onAccountFormChange = this.onAccountFormChange.bind(this);
    this.onFirmwareFormChange = this.onFirmwareFormChange.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.submitUpdateApp = this.submitUpdateApp.bind(this);
    this.onSubmitAlertForm = this.onSubmitAlertForm.bind(this);
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
    this.setState(state => {
      state.email = nextProps.email || '';
      state.phone = nextProps.phone || '';
      return state;
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  onChangeActionMode(mode) {
    this.setState(state => state.mode = mode);
    if (mode === ACTION_MODE.REPORT) {
      if (this.getLog !== null) {
        let data = new Date();
        let formatedDate = data.getFullYear() + "-" + (data.getMonth() + 1).pad(2) + "-" + data.getDate().pad(2);
        console.log("date " + formatedDate);
        this.getLog(formatedDate);
      }
    }
  }

  onChangeNewAccount(isActive) {
    this.setState(state => {
      state.newAccount = isActive;
      state.accountForm.userName = '';
      state.accountForm.password = '';
      state.accountForm.newPassword = '';
      state.accountForm.verifyPassword = '';
      return state;
    });
  }

  onChangePassword(isActive) {
    this.setState(state => {
      state.changePassword = isActive;
      state.accountForm.password = '';
      state.accountForm.newPassword = '';
      state.accountForm.verifyPassword = '';
      return state;
    });
  }

  onChangeNewFirmware(isActive) {
    this.setState(state => state.newFirmware = isActive);
  }

  onClickClose() {
    if (this.onClose) {
      this.onClose();
    }
  }

  navBarView() {
    return(
      <div>
        <Container className='user'>
          <Row>
            <Col xs={2}>
              <img src={avatar} className='user-icon' />
            </Col>
            <Col xs={7} style={{margin: 'auto'}}>
              <p className='user-name'>
                {this.user}
              </p>
            </Col>
          </Row>
        </Container>
        <Container style={{margin: '0', padding: '0'}}>
          <ListGroup style={{padding: '1.5em 0em'}} defaultActiveKey='#1'>
            <ListGroup.Item className='nav-item' action href='#1' onClick={() => this.onChangeActionMode(ACTION_MODE.ACCOUNT)}>
              <Row>
                <Col xs={3}>
                  <RiLayoutMasonryFill size={30}/>
                </Col>
                <Col xs={9} style={{textAlign: 'left', margin: '0', padding: '0'}}>
                  Quản lý chung
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item className='nav-item' action href='#4' onClick={() => this.onChangeActionMode(ACTION_MODE.REPORT)}>
              <Row>
                <Col xs={3}>
                  <AiOutlineFileExclamation size={30}/>
                </Col>
                <Col xs={9} style={{textAlign: 'left', margin: '0', padding: '0'}} >
                  Báo cáo
                </Col>
              </Row>
            </ListGroup.Item>
          </ListGroup>
        </Container>
        <Container style={{bottom: '2em', position: 'absolute'}}>
          <Button variant='danger' style={{width: '6em'}} onClick={() => this.onClickClose()}>
            <Row style={{margin: '0', padding: '0'}}>
              <Col style={{margin: '0', padding: '0', textAlign: 'center'}}>
                Thoát
              </Col>
            </Row>
          </Button>
        </Container>
      </div>
    )
  }

  onClickDeleteAccount(userId) {
    if (this.onDeleteAccount !== null) {
      this.onDeleteAccount(userId);
    }
  }

  onAccountFormChange(type, data) {
    this.setState(state => {
      switch (type) {
        case 'userName':
          state.accountForm.userName = data;
          break;
        case 'password':
          state.accountForm.password = data;
          break;
        case 'verifyPassword':
          state.accountForm.verifyPassword = data;
          break;
        case 'role':
          state.accountForm.role = data;
          break;
        case 'newPassword':
          state.accountForm.newPassword = data;
      }
      return state;
    });
  }

  onSubmitNewAccount() {
    console.log("%s %s %s", this.state.accountForm.userName, this.state.accountForm.password, this.state.accountForm.verifyPassword)
    if (this.state.accountForm.password !== this.state.accountForm.verifyPassword) {
      window.api.send('asynchronous-message', 'dialog', null, null, "Mật khẩu xác nhận không khớp !");
      return;
    }
    if (this.state.accountForm.userName === '') {
      window.api.send('asynchronous-message', 'dialog', null, null, "Lỗi: Tên đăng nhập trống");
      return;
    }
    if (this.state.accountForm.userName.includes(' ')) {
      window.api.send('asynchronous-message', 'dialog', null, null, "Lỗi: Tên đăng nhập không được có khoảng trắng");
      return;
    }
    if (this.state.accountForm.password.length < 8) {
      window.api.send('asynchronous-message', 'dialog', null, null, "Lỗi: Độ dài mật khẩu tối thiểu là 8 ký tự");
      return;
    }
    if (this.state.accountForm.role !== 2 && this.state.accountForm.role !== 3) {
      window.api.send('asynchronous-message', 'dialog', null, null, "Lỗi: Vai trò tài khoản không hợp lệ");
      return;
    }
    if (this.onCreateNewAccount !== null) {
      this.onCreateNewAccount(
        this.state.accountForm.userName,
        sha256(this.state.accountForm.password).toString(),
        this.state.accountForm.role
      )
    }
  }

  onSubmitChangePassword() {
    let password = this.state.accountForm.password;
    let newPassword = this.state.accountForm.newPassword;
    let verifyPassword = this.state.accountForm.verifyPassword;
    console.log("%s %s %s", password, newPassword, verifyPassword);

    if (newPassword !== verifyPassword) {
      window.api.send('asynchronous-message', 'dialog', null, null, "Mật khẩu xác nhận không khớp !");
      return;
    }

    if (newPassword.length < 8) {
      window.api.send('asynchronous-message', 'dialog', null, null, "Lỗi: Độ dài mật khẩu tối thiểu là 8 ký tự");
      return;
    }

    if (this.changePassword !== null) {
      this.changePassword(
        sha256(password).toString(),
        sha256(newPassword).toString()
      )
    }
  }

  accountView(accountList) {
    let listView = [];
    accountList?.forEach((account, index) => {
      listView.push(
        <Row className='item-row'>
          <Col style={{margin: 'auto'}}>
            {index + 1}
          </Col>
          <Col style={{margin: 'auto'}}>
            {account.userName}
          </Col>
          <Col style={{margin: 'auto'}}>
            {account.role === 1 ? 'Quản trị' : (account.role === 2 ? 'Vận hành' : 'Giám sát')}
          </Col>
          <Col style={{margin: 'auto'}}>
            {account.createDate === '' ? '20/01/2021' : account.createDate}
          </Col>
          <Col style={{margin: 'auto'}}>
            <Button
              variant='danger'
              onClick={() => this.onClickDeleteAccount(account.userId)}
            >
              Xóa
            </Button>
          </Col>
        </Row>
      )
    })
    return (
      <Container className='tag-card'>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Container className='monitor-station-title'>
              <p className='monitor-station-title-text'>
                Quản lý tài khoản
              </p>
            </Container>
          </Col>
        </Row>
        {this.props.role === 1 &&
        <div>
          <Row style={{paddingBottom: '1em'}}>
            <Col>
              <Row>
                <Col>
                  <p className='light-setting-title'>
                    Danh sách tài khoản
                  </p>
                </Col>
              </Row>
              <Row className='item-row'>
                <Col style={{margin: 'auto'}}>
                  No.
                </Col>
                <Col>
                  Tên tài khoản
                </Col>
                <Col>
                  Vai trò
                </Col>
                <Col>
                  Ngày cấp
                </Col>
                <Col>
                  Xóa tài khoản
                </Col>
              </Row>
              {listView}
            </Col>
          </Row>
          <Row style={{paddingBottom: '1em'}}>
            <Col>
              {this.state.newAccount === false &&
              <Button
                onClick={() => this.onChangeNewAccount(true)}
              >
                Tạo tài khoản
              </Button>
              }
              {this.state.newAccount === true &&
              <div>
                <Row>
                  <Col>
                    <p className='light-setting-title'>
                      Tạo tài khoản
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={5} className='form-left'>
                    Tên tài khoản:
                  </Col>
                  <Col xs={7} className='form-right'>
                    <input
                      type='text'
                      value={this.state.accountForm.userName}
                      onChange={(event => {
                        this.onAccountFormChange('userName', event.target.value)
                      })}
                      style={{width: '15em'}}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={5} className='form-left'>
                    Mật khẩu:
                  </Col>
                  <Col xs={7} className='form-right'>
                    <input
                      type='password'
                      value={this.state.accountForm.password}
                      onChange={(event => {
                        this.onAccountFormChange('password', event.target.value)
                      })}
                      style={{width: '15em'}}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={5} className='form-left'>
                    Nhập lại mật khẩu:
                  </Col>
                  <Col xs={7} className='form-right'>
                    <input
                      type='password'
                      value={this.state.accountForm.verifyPassword}
                      onChange={(event => {
                        this.onAccountFormChange('verifyPassword', event.target.value)
                      })}
                      style={{width: '15em'}}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={5} className='form-left'>
                    Vai trò:
                  </Col>
                  <Col xs={7} className='form-right'>
                    <Dropdown variant='outline-secondary'>
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        id="dropdown-basic"
                        style={{width: '15em'}}
                      >
                        {this.state.accountForm.role === 2 ? 'Vận hành' : 'Giám sát'}
                      </Dropdown.Toggle>

                      <Dropdown.Menu onSelect={(data) => console.log(data)}>
                        <Dropdown.Item href="#/action-1" onClick={() => this.onAccountFormChange('role', 2)}>Vận
                          hành</Dropdown.Item>
                        <Dropdown.Item href="#/action-2" onClick={() => this.onAccountFormChange('role', 3)}>Giám
                          sát</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
                <Row>
                  <Col className='form-left'>
                    <Button
                      variant='danger'
                      onClick={() => this.onChangeNewAccount(false)}
                    >
                      Hủy
                    </Button>
                  </Col>
                  <Col className='form-right'>
                    <Button
                      onClick={() => this.onSubmitNewAccount()}
                    >
                      Xác nhận
                    </Button>
                  </Col>
                </Row>
              </div>
              }
            </Col>
          </Row>
        </div>
        }
        <Row>
          <Col>
            {this.state.changePassword === false &&
            <Button
              onClick={() => this.onChangePassword(true)}
              variant='outline-danger'
            >
              Đổi mật khẩu
            </Button>
            }
            {this.state.changePassword === true &&
            <div>
              <Row>
                <Col>
                  <p className='light-setting-title'>
                    Đổi mật khẩu
                  </p>
                </Col>
              </Row>
              <Row>
                <Col xs={5} className='form-left'>
                  Mật khẩu cũ:
                </Col>
                <Col xs={7} className='form-right'>
                  <input
                    type='password'
                    value={this.state.accountForm.password}
                    onChange={(event => {
                      this.onAccountFormChange('password', event.target.value)
                    })}
                    style={{width: '15em'}}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={5} className='form-left'>
                  Mật khẩu mới:
                </Col>
                <Col xs={7} className='form-right'>
                  <input
                    type='password'
                    value={this.state.accountForm.newPassword}
                    onChange={(event => {
                      this.onAccountFormChange('newPassword', event.target.value)
                    })}
                    style={{width: '15em'}}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={5} className='form-left'>
                  Nhập lại mật khẩu mới:
                </Col>
                <Col xs={7} className='form-right'>
                  <input
                    type='password'
                    value={this.state.accountForm.verifyPassword}
                    onChange={(event => {
                      this.onAccountFormChange('verifyPassword', event.target.value)
                    })}
                    style={{width: '15em'}}
                  />
                </Col>
              </Row>
              <Row>
                <Col className='form-left'>
                  <Button
                    variant='danger'
                    onClick={() => this.onChangePassword(false)}
                  >
                    Hủy
                  </Button>
                </Col>
                <Col className='form-right'>
                  <Button
                    onClick={() => this.onSubmitChangePassword()}
                  >
                    Xác nhận
                  </Button>
                </Col>
              </Row>
            </div>
            }
          </Col>
        </Row>
      </Container>
    )
  }

  onFirmwareFormChange(type, data) {
    this.setState(state => {
      if (type === 'version') {
        state.firmwareForm.version = data;
      } else if (type === 'filePath') {
        state.firmwareForm.filePath = data;
      }
      return state;
    })
  }

  onSubmitFirmware() {
    if (this.uploadFirmware !== null) {
      this.uploadFirmware(this.state.firmwareForm.version, this.state.firmwareForm.filePath);
    }
  }

  submitDeleteStation(stationId) {
    if (this.deleteStation !== null) {
      this.deleteStation(stationId);
    }
  }

  deviceView(stationList) {
    let stations = [];
    stationList?.forEach((station, index) => {
      stations.push(
        <Row className='item-row'>
          <Col style={{margin: 'auto'}}>
            {index + 1}
          </Col>
          <Col style={{margin: 'auto'}}>
            {station.name}
          </Col>
          <Col style={{margin: 'auto'}}>
            {station.hardwareId}
          </Col>
          <Col style={{margin: 'auto'}}>
            {station.firmware}
          </Col>
          <Col style={{margin: 'auto'}}>
            {station.createDate === '' ? '21/02/2021' : station.createDate}
          </Col>
          <Col>
            <Button
              variant='danger'
              onClick={() => {this.submitDeleteStation(station.id)}}
            >
              Xóa
            </Button>
          </Col>
        </Row>
      )
    })
    return (
      <Container className='tag-card'>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Container className='monitor-station-title'>
              <p className='monitor-station-title-text'>
                Quản lý trạm
              </p>
            </Container>
          </Col>
        </Row>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Row>
              <Col>
                <p className='light-setting-title'>
                  Danh sách trạm
                </p>
              </Col>
            </Row>
            <Row className='item-row'>
              <Col>
                No.
              </Col>
              <Col>
                Tên trạm
              </Col>
              <Col>
                Mã thiết bị
              </Col>
              <Col>
                Phiên bản
              </Col>
              <Col>
                Ngày tạo
              </Col>
              <Col>
                Xóa trạm
              </Col>
            </Row>
          </Col>
        </Row>
        {stations}
        <Row>
          <Col>
            <Alert variant='success'>
              Phiên bản mới nhất hiện tại - Verison {this.props.latestFirmware}
            </Alert>
          </Col>
        </Row>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            {this.state.newFirmware === false &&
            <Button
              onClick={() => this.onChangeNewFirmware(true)}
            >
              Tải firmware
            </Button>
            }
            {this.state.newFirmware === true &&
            <div>
              <Row>
                <Col>
                  <p className='light-setting-title'>
                    Tải firmware mới
                  </p>
                </Col>
              </Row>
              <Row>
                <Col xs={5} className='form-left'>
                  Phiên bản:
                </Col>
                <Col xs={7} className='form-right'>
                  <input
                    type='text'
                    onChange={(event) => this.onFirmwareFormChange('version', event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={5} className='form-left'>
                  File:
                </Col>
                <Col xs={7} className='form-right'>
                  <input
                    type='file'
                    onChange={(event) => this.onFirmwareFormChange('filePath', event.target.files[0])}
                  />
                </Col>
              </Row>
              <Row>
                <Col className='form-left'>
                  <Button
                    variant='danger'
                    onClick={() => this.onChangeNewFirmware(false)}
                  >
                    Hủy
                  </Button>
                </Col>
                <Col className='form-right'>
                  <Button
                    onClick={() => this.onSubmitFirmware()}
                  >
                    Xác nhận
                  </Button>
                </Col>
              </Row>
            </div>
            }
          </Col>
        </Row>
      </Container>
    )
  }

  submitUpdateApp() {
    if (this.onUpdateApp !== null) {
      this.onUpdateApp();
      this.setState(state => state.disableDownload = true);
    }
  }

  softwareView() {
    return (
      <Container className='tag-card'>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Container className='monitor-station-title'>
              <p className='monitor-station-title-text'>
                Phần mềm
              </p>
            </Container>
          </Col>
        </Row>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Row>
              <Col>
                <p className='light-setting-title'>
                  Cập nhật phần mềm
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Alert variant={config.version !== this.props.latestApp ? 'warning' : 'success'}>
                  <Row>
                    <Col className='form-left' style={{margin: 'auto'}}>
                      <p style={{margin: 'auto'}}>
                        Version hiện tại {config.version}
                      </p>
                    </Col>
                    <Col className='form-right'>
                      {config.version === this.props.latestApp ? '(Phiên bản mới nhất)' :
                        <Button
                          variant={'danger'}
                          onClick={() => this.submitUpdateApp()}
                          disabled={this.state.disableDownload}
                        >
                          {this.state.disableDownload ? 'Đang tải...' : 'Cập nhật'}
                        </Button>
                      }
                    </Col>
                  </Row>
                </Alert>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }

  onSubmitAlertForm() {
    if (this.changeAlertInfo !== null) {
      this.changeAlertInfo(this.state.alertForm.email, this.state.alertForm.phone);
    }
  }

  alertView() {
    return (
      <Container className='tag-card'>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Container className='monitor-station-title'>
              <p className='monitor-station-title-text'>
                Tiếp nhận cảnh báo
              </p>
            </Container>
          </Col>
        </Row>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Row>
              <Col>
                <p className='light-setting-title'>
                  Thông tin tiếp nhận cảnh báo lỗi
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Row>
                  <Col xs={5} className='form-left'>
                    Email nhận cảnh báo:
                  </Col>
                  <Col xs={7} className='form-right'>
                    <input
                      type='email'
                      value={this.state.alertForm.email}
                      onChange={(event) => this.setState(state => state.alertForm.email = event.target.value)}
                      style={{width: '15em'}}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col xs={5} className='form-left'>
                    Số điện thoại nhận cảnh báo:
                  </Col>
                  <Col xs={7} className='form-right'>
                    <input
                      type='tel'
                      pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                      value={this.state.alertForm.phone}
                      onChange={(event) => this.setState(state => state.alertForm.phone = event.target.value)}
                      style={{width: '15em'}}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{paddingTop: '1em'}}>
              <Col>
                <Button
                  variant={'danger'}
                  onClick={() => this.onSubmitAlertForm()}
                >Lưu lại</Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }

  generalView(accountList, stationList) {
    return (
      <div>
        {this.accountView(accountList)}
        {this.alertView()}
        {this.deviceView(stationList)}
        {this.softwareView()}
      </div>
    )
  }

  onChangeReportDate(date) {
    this.setState(state => state.dateValue = date);
    let data = new Date(date);
    let formatedDate = data.getFullYear() + "-" + (data.getMonth() + 1).pad(2) + "-" + data.getDate().pad(2);
    console.log("date " + formatedDate);
    if (this.getLog !== null) {
      this.getLog(formatedDate);
    }
  }

  reportView() {
    return (
      <Container className='tag-card'>
        <Row style={{paddingBottom: '1em'}}>
          <Col>
            <Container className='monitor-station-title'>
              <p className='monitor-station-title-text'>
                Báo cáo
              </p>
            </Container>
          </Col>
        </Row>
        <Row style={{
          padding: '1em'
        }}>
          <Col xs={5} className='form-left'>
            Chọn ngày
          </Col>
          <Col xs={7} className='form-right'>
            <DateTimePicker
              disableClock={true}
              format={'dd-MM-yyyy'}
              value={this.state.dateValue}
              onChange={(value) => this.onChangeReportDate(value)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Container style={{
              height: '45em',
              overflow: 'scroll',
              padding: '1em',
              border: '2px solid rgba(76, 76, 76, 0.32)'
            }}>
              <p style={{
                whiteSpace: "pre-line",
                textAlign: 'left',
                fontSize: '18px'
              }}>
                {this.props.logContent}
              </p>
            </Container>
          </Col>
        </Row>
      </Container>
    )
  }

  render() {
    return (
      <Container fluid className='container-center' style={{margin: '0px'}}>
        <Row>
          <Col xs={2} className='col-selection'>
            {/*<img src={navBar} width='100%'/>*/}
            {this.navBarView()}
          </Col>
          <Col xs={10}
               style={{
                 maxHeight: '100vh',
                 overflowX: 'hidden',
                 overflowY: 'scroll'
               }}>
            {this.state.mode === ACTION_MODE.ACCOUNT &&
              this.generalView(this.props.accountList, this.props.stationList)
            }
            {this.state.mode === ACTION_MODE.REPORT &&
              this.reportView()
            }
          </Col>
        </Row>
      </Container>
    )
  }
}